<template lang="html">

    <Form  v-if="form" :label-width="200" @submit.prevent.native="post(form,roles)" :model="form" :show-message="false">
      <FormItem label="Username" :rules="{required:true}"  prop="username">
        <Input v-model="form.name" :disabled="false"/>
      </FormItem>
      <FormItem label="Email" :rules="{required:true}"  prop="email">
        <Input v-model="form.email" :disabled="false"/>
      </FormItem>
      <FormItem label="Attivo fino al" :rules="{required:false}"  prop="date">
        <DatePicker v-model="form.expiration_date" :disabled="false"/>
        <Button type="info" @click="demoact()":disabled="false">
          <b>Attiva Demo</b>
        </Button>
      </FormItem>
      <hr>
      <div style="text-align: center;">
        <table v-if="roles.length!=0">
          <thead>
            <tr>
              <th>
                 Ruolo
              </th>
              <th>
                 Compagnia
              </th>
              <th>
                 Azioni
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="role in roles">
              <td>
                <FormItem :label-width="label_width" :rules="{required:true}">
              <Select v-model="role.role" :filterable="true">
                <Option value="admin">
                  Amministratore
                </Option>
                <Option value="president">
                  Presidente
                </Option>
                <Option value="vice">
                  Vice
                </Option>
             </Select>
            </FormItem>
              </td>
              <td>
                <FormItem :label-width="label_width" :rules="{required:true}">
              <Select v-model="role.company_id" :filterable="true">
              <Option v-for="companie in companies" :value="companie.id" :key="companie.id">{{ companie.name }}</Option>
              </Select>
            </FormItem>
              </td>
              <td>
                <Button type="error" size="small" @click="delRole(role)">
              <Icon type="trash-a"/>
            </Button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        
        <div style="text-align: right">
          <Button @click="addRole(form.id)" type = "info" >Aggiungi Ruolo</Button>
        </div>
        <hr>
        <div style="text-align: right">
              <Button type="error" @click="$parent.$parent.closeEdit()">
                 Annulla
              </Button>
               <Button type="primary" @click="post(form,roles)">
                 Salva
              </Button>
            </div>
      <input type="submit" style="display: none">
    </Form>
</template>

<script>
export default {
  data(){
    return{
      roles: [],
      companies: [],
      del_roles: [],
      label_width: 120,
    }
    
  },
  mounted(){
    this.getRoles(this.form.id)
    this.getCompanies()
  },
  
  props: ['form'],
  computed: {

  },
  methods: {
    post(form,roles) 
    {
      this.del_roles.forEach(role => {
        this.$http.delete('roles/'+role.id)
      })

      roles.forEach(role => {
        this.$http.post('roles',role)
      })
      this.getRoles(this.form.id)
      this.$parent.$parent.post(form)
      
    },
    getRoles(id)
    {
      this.$http.get('roles-edit/'+id).then(res => {
        this.roles = res.data
        })
    },
    delRole(role)
    {
      if(role.id!=null)
      {
        this.del_roles.push(role)
      }
      const index = this.roles.indexOf(role)
      if (index > -1) 
      { 
          this.roles.splice(index, 1)
      }
    },
    getCompanies()
    {
      this.$http.get('companies-form').then(res => {
        this.companies = res.data
        })
    },
    addRole(given_id) {
      //this.getRoles(this.form.id)
      this.roles.push({
        role: '',
        user_id: given_id,
        company_id: null,
        
      })
    },
    demoact()
    {
      let current = new Date();
      let cDate = (current.getFullYear()) + '-' + (current.getMonth() + 1) + '-' + (current.getDate());
      var intDate = Date.parse(cDate)
      let demoDate = intDate + ( 24 * 60 * 60 * 1000 * 14)
      let new_current= new Date()
      new_current.setTime(demoDate)
      let dDate = (new_current.getFullYear()) + '-' + (new_current.getMonth() + 1) + '-' + (new_current.getDate());
      this.form.expiration_date=dDate
      //this.form.expiration_date

    },
  }
}
</script>

<style lang="css" scoped>
</style>